import { Pipe, PipeTransform } from '@angular/core';
import { FondsFilterBlockData } from '../fonds-filters/fonds-filters';

@Pipe({
  name: 'filterGrid',
  standalone: true,
})
export class FondsFilterBlockGridPipe implements PipeTransform {
  public transform(value: FondsFilterBlockData): string {
    const rowsPerColumn: number = Math.ceil(value.options.length / 2);
    const columnWidth: string = value.options.length > 1 ? '1fr' : 'auto';
    return `grid-template-rows: repeat(${rowsPerColumn}, ${columnWidth});`;
  }
}
